"use strict";
exports.__esModule = true;
var FlexView_1 = require("./FlexView");
exports["default"] = FlexView_1.FlexView;



//////////////////
// WEBPACK FOOTER
// ../~/react-flexview/lib/index.js
// module id = 170
// module chunks = 0